<template>
  <list-view-layout :title="title" @on-add="$router.push({ path: '/upkeep/' + $route.params.model + '/create' })">
    <upkeep-data-table v-if="data.length" :data="data" :columns="columns" :model="$route.params.model" @needsUpdate="getData"></upkeep-data-table>
  </list-view-layout>
</template>

<script setup>

import {ref, watch} from "vue";
import ListViewLayout from "../../components/view-components/ListViewLayout.vue";
import UpkeepDataTable from "../../components/ui-components/UpkeepDataTable.vue";
const data = ref([]);
const title = ref();
const columns = ref([]);
const route = useRoute();
const getData = (newData = null) => {
  if(newData) {
    data.value = newData;
  }

}


</script>

<style scoped lang="scss">

</style>
